<ng-container *transloco="let t;">
  <app-list-view [title]="t('common.labels.textblocks')" [messages]="messages" [loading]="loading">

    <div buttons>
      <button withRight="admin.textblock.list" pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
      <button [withRight]="'admin.textblock.create'" pButton (click)="onNew()" type="button" label="{{ t('common.labels.new') }}" icon="pi pi-plus" class="p-button-success p-ml-2 p-mb-2 autofocus"></button>
    </div>

    <div table>
      <p-table
        [value]="textblocks"
        [paginator]="true"
        [rows]="20"
        stateStorage="local"
        stateKey="textblock-list"
        [rowsPerPageOptions]="rowsPerPage"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="t('common.labels.current_page_report')"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="identifier">{{ t('common.labels.identifier') }}
              <p-sortIcon field="identifier"></p-sortIcon>
            </th>
            <th pSortableColumn="type">{{ t('common.labels.type') }}
              <p-sortIcon field="type"></p-sortIcon>
            </th>
            <th>{{ t('common.labels.description') }}</th>
            <th>{{ t('common.labels.languages') }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-textblock>
          <tr (click)="onOpen(textblock)" (keyup.enter)="onOpen(textblock)" hoverOnRight="admin.textblock.show" tabindex="0">
            <td><span role="link">{{textblock.identifier}}</span></td>
            <td><span role="link">{{ t('common.labels.' + textblock.type) }}</span></td>
            <td><span role="link">{{textblock.description}}</span></td>
            <td><span role="link">{{textblock.language_list}}</span></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="no-data" colspan="4">{{ t('common.labels.no_data') }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </app-list-view>
</ng-container>
